import { React, useEffect } from "react";
import { Link } from "react-router-dom";

import ContactUs from "./HomeComponents/ContactUs";

let imgs = [
  "https://images.unsplash.com/photo-1633596683562-4a47eb4983c5?q=80&w=3432&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "https://images.unsplash.com/photo-1692485595126-c9e934aa95d0?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "https://images.unsplash.com/photo-1629729802306-2c196af7eef5?q=80&w=3560&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "https://images.unsplash.com/photo-1621839673705-6617adf9e890?q=80&w=3432&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "https://images.unsplash.com/photo-1589149098258-3e9102cd63d3?q=80&w=3439&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "https://images.unsplash.com/photo-1676676701395-5fd57415a91a?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
];

const Service = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container">
        <div className="services-page">
          <div className="hero">
            <h1 className="hero-title">
              Dive into the world of stellar web creation. No matter what you
              need, we’ve got an incredible solution right here!
            </h1>
            <div className="main__action">
              <div className="main__scroll" href="#">
                <div className="main__scroll-box">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.9997 13.1716L7.04996     8.22186L5.63574 9.63607L11.9997 16L18.3637 9.63607L16.9495 8.22186L11.9997 13.1716Z"></path>
                  </svg>
                </div>

                <span className="main__scroll-text">Scroll</span>
              </div>
            </div>
          </div>
          <div className="sub-hero top-trigger">
            <h3>Our Services</h3>
            <p>
              Ready to get a splendid website designed? A fairytale on cyber
              canvas? That‘s us! We‘re fiends of design, detailing and dedicated
              to your web place. Be it an electronic store, a landing gem or a
              product showcase – we‘ve got you covered.
            </p>
          </div>
          <section className="carts-section services entry">
            <div className="entry_secondary">
              <div className="grid">
                <div className="item">
                  <div className="image">
                    <img
                      
                      src={imgs[0]}
                      alt="E-commerce Extravaganza"
                    />
                  </div>
                  <div className="content">
                    <h2>E-commerce Extravaganza</h2>
                    <p>
                      Harnessed with all the e-commerce essentials, we create
                      superlative shopping spaces that convert.
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="image">
                    <img  src={imgs[1]} alt="Landing Pages" />
                  </div>
                  <div className="content">
                    <h2>Landing Pages</h2>
                    <p>
                      Pitch perfect landing pages that hook the visitors and
                      drive conversions.
                    </p>
                  </div>
                </div>
                <div className="item">
                  <div className="image">
                    <img  src={imgs[2]} alt="Product Websites" />
                  </div>
                  <div className="content">
                    <h2>Product Websites</h2>
                    <p>
                      Product showcasing that hypnotize the viewers and push
                      them into the conversion funnel.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="frame-section ">
            <div className="frame-wrapper entry">
              <div className="frame-left entry_main">
                <div className="frame-title">
                  <h3>Full-cycle development</h3>
                </div>
                <p>
                  We kick templates to the curb and handcraft web solutions
                  tailor-made for your brand's distinct identity. From whimsical
                  to professional, we've got you covered!
                </p>
                <Link to="/service/full-cycle">
                  <div className="button ">
                    <p>Learn more</p>
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M18.3828 10.8828C18.8711 10.3945 18.8711 9.60156 18.3828 9.11328L12.1328 2.86328C11.6445 2.375 10.8516 2.375 10.3633 2.86328C9.875 3.35156 9.875 4.14453 10.3633 4.63281L15.7305 10L10.3672 15.3672C9.87891 15.8555 9.87891 16.6484 10.3672 17.1367C10.8555 17.625 11.6484 17.625 12.1367 17.1367L18.3867 10.8867L18.3828 10.8828ZM4.63281 17.1328L10.8828 10.8828C11.3711 10.3945 11.3711 9.60156 10.8828 9.11328L4.63281 2.86328C4.14453 2.375 3.35156 2.375 2.86328 2.86328C2.375 3.35156 2.375 4.14453 2.86328 4.63281L8.23047 10L2.86719 15.3672C2.37891 15.8555 2.37891 16.6484 2.86719 17.1367C3.35547 17.625 4.14844 17.625 4.63672 17.1367L4.63281 17.1328Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </div>
                </Link>
              </div>
              <div className="frame-image entry_secondary">
                <img  src={imgs[3]} alt="" />
              </div>
            </div>
            <div className="frame-wrapper entry">
              <div className="frame-left entry_secondary">
                <div className="frame-title">
                  <h3>Web App Design</h3>
                </div>
                <p>
                  Our expertise doesn't just stop at website creation. We offer
                  services spanning landing page design, redesigns and more, all
                  with our innovative 3D twist.
                </p>
                <Link to="/service/design">
                  <div className="button ">
                    <p>Learn more</p>{" "}
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M18.3828 10.8828C18.8711 10.3945 18.8711 9.60156 18.3828 9.11328L12.1328 2.86328C11.6445 2.375 10.8516 2.375 10.3633 2.86328C9.875 3.35156 9.875 4.14453 10.3633 4.63281L15.7305 10L10.3672 15.3672C9.87891 15.8555 9.87891 16.6484 10.3672 17.1367C10.8555 17.625 11.6484 17.625 12.1367 17.1367L18.3867 10.8867L18.3828 10.8828ZM4.63281 17.1328L10.8828 10.8828C11.3711 10.3945 11.3711 9.60156 10.8828 9.11328L4.63281 2.86328C4.14453 2.375 3.35156 2.375 2.86328 2.86328C2.375 3.35156 2.375 4.14453 2.86328 4.63281L8.23047 10L2.86719 15.3672C2.37891 15.8555 2.37891 16.6484 2.86719 17.1367C3.35547 17.625 4.14844 17.625 4.63672 17.1367L4.63281 17.1328Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </div>
                </Link>
              </div>
              <div className="frame-image entry_main">
                <img  src={imgs[4]} alt="" />
              </div>
            </div>
            <div className="frame-wrapper entry">
              <div className="frame-left entry_main">
                <div className="frame-title">
                  <h3>Web App Re-design</h3>
                </div>
                <p>
                  When your web app's design feels more like a speed bump than a
                  highway, it's makeover time! Say goodbye to the old and hello
                  to growth with a sleek, revamped design.
                </p>
                <Link to="/service/re-design">
                  <div className="button ">
                    <p>Learn more</p>{" "}
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M18.3828 10.8828C18.8711 10.3945 18.8711 9.60156 18.3828 9.11328L12.1328 2.86328C11.6445 2.375 10.8516 2.375 10.3633 2.86328C9.875 3.35156 9.875 4.14453 10.3633 4.63281L15.7305 10L10.3672 15.3672C9.87891 15.8555 9.87891 16.6484 10.3672 17.1367C10.8555 17.625 11.6484 17.625 12.1367 17.1367L18.3867 10.8867L18.3828 10.8828ZM4.63281 17.1328L10.8828 10.8828C11.3711 10.3945 11.3711 9.60156 10.8828 9.11328L4.63281 2.86328C4.14453 2.375 3.35156 2.375 2.86328 2.86328C2.375 3.35156 2.375 4.14453 2.86328 4.63281L8.23047 10L2.86719 15.3672C2.37891 15.8555 2.37891 16.6484 2.86719 17.1367C3.35547 17.625 4.14844 17.625 4.63672 17.1367L4.63281 17.1328Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </div>
                </Link>
              </div>
              <div className="frame-image entry_secondary">
                <img  src={imgs[5]} alt="" />
              </div>
            </div>
          </section>
        </div>
      </div>
      <ContactUs />
    </>
  );
};

export default Service;
